/* eslint-disable import/no-unused-modules */
import type { LearningCardProps } from '@/administration/pages/Journey/common/atoms/LearningCard/LearningCard';
import { JourneyUpNextLearning } from '@/features/journey/admin/atoms/JourneyUpNextLearning';
import type { UpNextAllItemsLockedInformerProps } from '@/features/journey/admin/atoms/UpNextAllItemsLockedInformer';

type StartUpNextProps = {
  learningCardProps?: LearningCardProps;
  actionHref: string;
  parentJourneyId?: number;
  allUpcomingItemsLocked?: boolean;
} & Pick<UpNextAllItemsLockedInformerProps, 'unlockAt'>;

export const StartUpNext = ({
  learningCardProps,
  actionHref,
  parentJourneyId,
  allUpcomingItemsLocked,
  unlockAt,
}: StartUpNextProps): JSX.Element | null => {
  return (
    <JourneyUpNextLearning
      isActionActive
      learningCardProps={learningCardProps ? { ...learningCardProps, variant: 'compact' } : undefined}
      actionHref={actionHref}
      parentJourneyId={parentJourneyId}
      allUpcomingItemsLocked={allUpcomingItemsLocked}
      unlockAt={unlockAt}
    />
  );
};
